import { render, staticRenderFns } from "./emigreren.vue?vue&type=template&id=40e9170a"
import script from "./emigreren.vue?vue&type=script&lang=js"
export * from "./emigreren.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports